<template>
  <add-edit-dialog>
    <crm-panel title="新增商机">
      <div class="page-buttons">
        <crm-button :text="'保存'" @click="handleSave()"> </crm-button>
        <crm-button :buttonType="'plain'" :text="'取消'" @click="handleCancel()">
        </crm-button>
      </div>
      <div class="sub-header">
        <span>基本信息</span>
      </div>
      <el-form
        label-width="160px"
        ref="addForm"
        :model="addForm"
        :rules="addFormRules"
        class="add-edit-form"
      >
        <el-row>
          <el-col :span="8" :offset="3">
            <cusname-select
              v-if="!customId"
              :customSelectSearch="customSelectSearch"
              :customSelectData="CustomSelectData"
              :val="addForm.customerId"
              @change="handleCusNameChange"
            >
            </cusname-select>
            <el-form-item
              v-if="customId"
              label="客户名称："
              prop="customName"
              :rules="{ required: true }"
            >
              <el-input v-model="addForm.customName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业务员：" prop="userId">
              <el-select clearable @change="busiSalesChange" v-model="addForm.userId">
                <el-option
                  :key="item.id"
                  v-for="item in customSalesman"
                  :label="item.salesmanName"
                  :value="item.salesmanCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="商机名称：" prop="name">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人：" prop="converts">
              <el-select
                multiple
                clearable
                v-model="addForm.converts"
                @change="getContactDepa"
                @remove-tag="removeContactDepa"
              >
                <el-option
                  :key="item.uid"
                  v-for="item in contactsSelect"
                  :label="`${item.name}${
                    item.contactDepa ? ' - ' + item.contactDepa : ''
                  }`"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="预计成交金额(元)：" prop="dealAmountStr">
              <el-input v-model="addForm.dealAmountStr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预计成交日期：" prop="dealDateStr">
              <el-date-picker
                format="yyyy-MM-dd"
                :editable="false"
                value-format="yyyy-MM-dd"
                v-model="addForm.dealDateStr"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="客户意向：" prop="intention">
              <el-input type="textarea" :rows="4" v-model="addForm.intention"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注：" prop="remarks">
              <el-input type="textarea" :rows="4" v-model="addForm.remarks"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row> -->
        <!-- <el-col :span="8">
            <el-form-item label="联系人部门：" prop="contactDepaList">
              <el-input v-model="addForm.contactDepa"> </el-input>
            </el-form-item>
          </el-col> -->
        <!-- </el-row> -->
      </el-form>
      <div class="sub-header">
        <span>产品线(至少添加一个产品线)</span>
        <crm-button
          v-if="
            businessAuth.bizProductLineAdd && businessAuth.bizProductLineAdd.toggleStatus
          "
          :size="'mini'"
          type="text"
          :text="'添加'"
          @click="handleAddProduct()"
        >
        </crm-button>
      </div>
      <el-table height="170" :data="addForm.businessLineList" border style="width: 100%">
        <el-table-column
          show-overflow-tooltip
          label="产品线名称"
          prop="businessLineName"
          align="center"
        >
        </el-table-column>
        <el-table-column label="产品线预计成交金额(元)" prop="dealAmount" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.dealAmount) }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button
              v-if="
                businessAuth.bizProductLineDel &&
                businessAuth.bizProductLineDel.toggleStatus
              "
              @click="handleDel(row)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </crm-panel>
    <!-- 新增编辑产品线 -->
    <edit-product-Line
      v-if="isProductLineDialogVisible"
      :visible="isProductLineDialogVisible"
      :detail="productLinetDetail"
      @refresh="refreshProductLine"
      @close="isProductLineDialogVisible = false"
    >
    </edit-product-Line>
  </add-edit-dialog>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import AddEditDialog from "@/components/base/addEditDialog";
import CrmPanel from "@/components/base/crmPanel";
import CrmButton from "@/components/base/crmButton";
import CusnameSelect from "@/components/business/custom/cusname-select";
import service from "@/services/api/business";
import EditProductLine from "~component/business/busiopportunity/editProductLine.vue";
import { formatMoney } from "@/scripts/utils";

export default {
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
    CusnameSelect,
    EditProductLine,
  },
  props: {
    visible: { type: Boolean },
    customId: { type: String },
    moduleName: { type: String },
    customName: {
      type: String,
      default: "",
    },
  },
  data() {
    const dealAmountStrRule = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写预计成交金额!"));
      } else if (!/^-?\d+\.?\d{0,2}$/.test(value)) {
        callback(new Error("请填写两位小数的数字!"));
      } else if (parseFloat(value) > 99999999999.99) {
        callback(new Error("不能超过99,999,999,999.99"));
      } else {
        callback();
      }
    };
    return {
      // 待提交的表单数据
      addForm: {
        customerId: "",
        customName: "",
        name: "",
        businessLineList: [],
        intention: "",
        dealAmountStr: "",
        dealDateStr: "",
        remarks: "",
        userId: "",
        converts: [],
        contactDepaList: [],
      },
      // 客户业务员下拉框数据
      customSalesman: [],
      // 联系人下拉框数据
      contactsSelect: [],
      // 业余员提交
      salesmanList: {
        customerUid: "",
        pageNumber: 1,
        pageSize: 20,
      },
      // 联系人提交
      contactsList: {
        customerUid: "",
        salesmanCode: "",
        pageNumber: 1,
        pageSize: 20,
      },
      // 表单校验规则
      addFormRules: {
        customerId: [{ required: true, message: "请选择客户名称", trigger: "change" }],
        name: [
          { required: true, message: "请填写商机名称", trigger: "change" },
          {
            min: 0,
            max: 30,
            message: "最多30个字",
            trigger: "blur",
          },
        ],
        intention: [
          { required: true, message: "请填写客户意向", trigger: "change" },
          {
            min: 0,
            max: 100,
            message: "最多100个字",
            trigger: "blur",
          },
        ],
        dealAmountStr: [
          { required: true, validator: dealAmountStrRule, trigger: "change" },
        ],
        dealDateStr: [
          { required: true, message: "请填写预计成交日期", trigger: "change" },
        ],
        remarks: [
          {
            min: 0,
            max: 200,
            message: "最多200个字",
            trigger: "blur",
          },
        ],
        userId: [{ required: true, message: "请选择业务员", trigger: "change" }],
        converts: [{ required: true, message: "请选择联系人", trigger: "blur" }],
      },
      canChoose: false,
      newBusiLineList: [],
      // 产品线新增编辑弹框
      isProductLineDialogVisible: false,
      productLinetDetail: {},
    };
  },
  computed: {
    ...mapGetters({
      businessAuth: "authority/businessAuth",
      CustomSelectData: "business/CustomSelectData",
      busiSalesList: "business/busiSalesList",
      busiContacts: "business/busiContacts",
      detailContacts: "business/detailContacts",
    }),
  },
  watch: {
    visible: {
      handler(val) {
        this.getAuthority({ menuUrl: "/business/opportunity" });
        this.customSalesman = [];
        this.contactsSelect = [];
        if (val && this.customName) this.addForm.customName = this.customName;
        if (val && this.customId) {
          this.addForm.customerId = this.customId;
          this.salesmanList.customerUid = this.customId;
          this.contactsList.customerUid = this.customId;
          this.getBusiSalesList(this.salesmanList).then(() => {
            if (this.busiSalesList.length > 0) {
              this.addForm.userId = this.busiSalesList[0].salesmanCode;
              this.busiSalesChange(this.busiSalesList[0].salesmanCode);
            }
          });
        }
      },
      immediate: true,
    },
    busiSalesList(val) {
      this.customSalesman = val;
    },
    busiContacts(val) {
      this.contactsSelect = val;
    },
  },
  methods: {
    formatMoney,
    ...mapActions({
      getAuthority: "authority/getAuthority",
      customSelectSearch: "business/CustomSelectSearch",
      saveAddBusiOpprtunity: "business/saveAddBusiOpprtunity",
      getBusiSalesList: "business/getBusiSalesList",
      getBusiContactsList: "business/getBusiContactsList",
      getDetailContactsList: "business/getDetailContactsList",
      getBusiLineList: "business/getBusiLineList",
    }),
    handleCusNameChange(value) {
      this.addForm.customerId = value;
      this.salesmanList.customerUid = value;
      this.contactsList.customerUid = value;
      this.addForm.userId = "";
      this.addForm.converts = [];
      if (value) {
        this.getBusiSalesList(this.salesmanList).then(() => {
          if (this.busiSalesList.length > 0) {
            this.addForm.userId = this.busiSalesList[0].salesmanCode;
            this.busiSalesChange(this.busiSalesList[0].salesmanCode);
          }
        });
      }
      if (!value) this.customSalesman = [];
      if (this.addForm.customerId && this.addForm.userId) {
        this.checkPermission();
        this.canChoose = true;
      } else {
        this.canChoose = false;
      }
    },
    removeContactDepa(val) {
      const check = this.contactsSelect.find((i) => i.uid === val);
      if (check && this.addForm.contactDepaList.includes(check.contactDepa)) {
        let index = 0;
        this.addForm.converts.forEach((item) => {
          if (
            this.contactsSelect.find((i) => i.uid === item).contactDepa ===
            check.contactDepa
          ) {
            index += 1;
          }
        });
        if (index === 0) {
          this.addForm.contactDepaList.splice(
            this.addForm.contactDepaList.indexOf(check.contactDepa),
            1
          );
        }
      }
    },
    getContactDepa(val) {
      val.forEach((item) => {
        const check = this.contactsSelect.find((i) => i.uid === item);
        if (check && !this.addForm.contactDepaList.includes(check.contactDepa)) {
          this.addForm.contactDepaList.push(check.contactDepa);
        }
      });
      this.checkPermission();
    },
    handleCancel() {
      this.$emit("close");
      // this.busiLineList = this.newBusiLineList || [];
      this.$refs.addForm.resetFields();
    },
    handleSave() {
      if (this.addForm.businessLineList.length <= 0) {
        this.$message.error("请至少添加一个产品线！");
        return;
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addForm.addConverts = [];
          this.addForm.addConverts = this.addForm.converts;
          const { id, converts, ...otherAddParams } = this.addForm;
          this.saveAddBusiOpprtunity({
            ...otherAddParams,
          }).then(() => {
            this.$message({
              type: "success",
              message: "新增成功！",
            });
            this.$refs.addForm.resetFields();
            this.$emit("close");
            // this.busiLineList = this.newBusiLineList;
            this.$emit("success");
          });
        }
      });
    },
    // 业务员选择
    async busiSalesChange(val) {
      this.contactsList.salesmanCode = val;
      this.addForm.converts = [];
      this.addForm.contactDepaList = [];
      this.addForm.businessLineList = [];
      if (val) {
        await this.getBusiContactsList(this.contactsList).then(() => {
          if (this.busiContacts.length > 0) {
            this.addForm.converts.push(this.busiContacts[0].uid);
            this.addForm.contactDepaList.push(this.busiContacts[0].contactDepa);
          }
        });
      }
      if (!val) this.contactsSelect = [];
      if (this.addForm.customerId && this.addForm.userId) {
        await this.checkPermission();
        this.canChoose = true;
      } else {
        this.canChoose = false;
      }
    },
    // 新增校验 在客户名称 业务员 产品线有值的时候 随意更改值都重新校验是否允许新增
    checkPermission() {
      if (this.moduleName === "opportunity") {
        service
          .apiGetDisabledBusinessLine({
            salesmanCode: this.addForm.userId,
            customerId: this.addForm.customerId,
            contactDepaList: this.addForm.contactDepaList,
          })
          .then((res) => {
            const result = res.data.data;
            // this.newBusiLineList = JSON.parse(
            //   JSON.stringify(this.busiLineList),
            // );
            // this.busiLineList.forEach((i) => {
            //   i['disabled'] = false;
            //   if (result.includes(i.uid)) {
            //     i['disabled'] = true;
            //   }
            // });
            this.$forceUpdate();
          })
          .finally(() => {
            this.canChoose = true;
          });
      }
    },
    // 添加产品线 btn
    async handleAddProduct() {
      console.log(this.addForm, "this.addForm");
      if (!this.addForm.customerId || !this.addForm.userId) {
        this.$message.error("请先选择客户名称以及业务员再选择产品线");
        return;
      }
      this.productLinetDetail = {
        id: "",
        type: "add",
        titleName: "添加",
        customerId: this.addForm.customerId,
        contactDepaList: this.addForm.contactDepaList,
      };
      console.log(this.productLinetDetail, "this.productLinetDetail");
      this.isProductLineDialogVisible = true;
    },
    refreshProductLine(productLineItem) {
      console.log(productLineItem, "productLineItem");
      // 有的覆盖 没有的新增
      if (this.addForm.businessLineList.length === 0) {
        this.addForm.businessLineList.push({
          businessLine: productLineItem.businessLine[1],
          dealAmount: productLineItem.dealAmount,
          businessLineName: productLineItem.businessLineName,
        });
      } else {
        this.addForm.businessLineList.forEach((item, index) => {
          if (
            item.businessLine !== productLineItem.businessLine[1] &&
            index >= this.addForm.businessLineList.length - 1
          ) {
            this.addForm.businessLineList.push({
              businessLineName: productLineItem.businessLineName,
              businessLine: productLineItem.businessLine[1],
              dealAmount: productLineItem.dealAmount,
            });
          } else if (item.businessLine === productLineItem.businessLine[1]) {
            item.dealAmount = productLineItem.dealAmount;
          }
        });
      }
    },
    handleDel(row) {
      this.$confirm(
        row.status === "1"
          ? "该产品线已被停用，删除后将无法再次添加，是否继续？"
          : "当前操作将从商机删除该产品线，是否继续？",
        "",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.addForm.businessLineList.forEach((item, index) => {
            if (item.id === row.id) {
              this.addForm.businessLineList.splice(index, 1);
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";

.dialog-add-busi {
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
.custom-select-item {
  width: 500px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.select-item-left {
  width: 350px;
  margin-right: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-tooltip__popper.is-dark {
  max-width: 1000px;
}
.sub-header {
  width: 100%;
  height: 30px;
  margin: 5px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px 0 0;
  box-sizing: border-box;
  background: #f0f3ff;
  color: #7a84b7;
  font-size: 16px;
  span {
    margin: 0 10px;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.dialog-wrap .add-edit-form {
  flex: initial;
}
</style>
